// ALL FORMS

document.addEventListener('DOMContentLoaded', (event) => {

    var forms = document.querySelectorAll('form[data-xhr]');
    
    forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
            formValidation(form, e);
        })
    });
    
});

function formValidation(form, e) {
    // prevent page refresh 
    e.preventDefault();

    if(typeof recaptcha_site_key_v3 !== 'undefined' && recaptcha_site_key_v3 !== undefined) {
        grecaptcha.ready(function() {				
            grecaptcha.execute(recaptcha_site_key_v3,{action: recaptcha_action}).then(function(token) {
                form.querySelector('[name="recaptcha"]').value = token;
                if (form.checkValidity()){
                    // send data
                    sendData(form);
                } else {
                    // 
                    form.reportValidity();
                } 
            });
        });
    } else {
        console.info("captcha not exist")
    };
}

function sendData(form) {
    console.info('Sending data');
    
    var form_body = form.querySelector('.form__body'),
        form_success = form.querySelector('.alert-success'),
        form_error = form.querySelector('.alert-danger'),
        form_captcha_error = form.querySelector('.alert-captcha'),
        btn = form.querySelector('[type="submit"]');

    // add btn loading
    btnLoading.add(btn);

    // clear invalid inputs
    form.querySelectorAll('.is-invalid').forEach((input) => {
        console.log(input);
        input.classList.remove('is-invalid');
    });

    // hide error message
    form_error.classList.add('d-none');
    form_captcha_error.classList.add('d-none');

    // create request and data
    const XHR = new XMLHttpRequest();
    const data = new FormData(form);
    const urlEncodedData = new URLSearchParams(data).toString();

    // successful
    XHR.addEventListener('load', (e) => {

        // process response
        if (e.target.response){
            //console.log(e.target.response);
            var response = JSON.parse(e.target.response);

            // BE validation
            if (response.success){
                // successful
                // finish form action
                if (response.redirect_url){
                    window.location.replace(response.redirect_url);
                } else {                                                    
                    if (document.getElementById('request-resources-form')) {
                        const requestResourcesModal = document.getElementById('requestResourcesModal');
                        requestResourcesModal.querySelector('#success-sending-provided-email')
                            .innerHTML = requestResourcesModal.querySelector('#email').value;
                    }
                    form_body.classList.add('d-none');                  
                    form_success.classList.remove('d-none');                  
                }
            } else {
                // invalid
                console.log(response);
                response.invalid.forEach((input) => {
                    if (input == 'recaptcha') {
                        form_captcha_error.classList.remove('d-none');
                    } else {
                        form.querySelector(`[name="${input}"]`).classList.add('is-invalid');
                    };
                });
            }
            
            // btnLoading.rem(btn);            
            // clear loading
            btn.innerHTML = btn_content;  
            btn.disabled = false;
        }
    });
    
    // error
    XHR.addEventListener('error', (e) => {
        // remove btn loading
        btnLoading.rem(btn);	
        form_error.classList.remove('d-none');
    });

    // Set up request
    XHR.open('POST', cyclone3.domain + '/json/' + form.dataset.service);

    // Add the required HTTP header for form data POST requests
    XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    // Send our data.
    XHR.send(urlEncodedData);
};